module.exports = __webpack_public_path__ + "static/media/leadar-logo.88404263.png";